import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import { CircularProgress } from '@mui/material';
import {Typography} from '@mui/material';

const styles = (theme:Theme):StyleRules => ({
  container: {
    width: "100%",
    textAlign: "center",
    marginTop: 40
  },
  compactContainer: {
    width: "100%",
    textAlign: "center",
  },
  overlayContainer:{
      position: "absolute",
      zIndex: 10000,
      backgroundColor: "rgba(255,255,255,.25)",
      top: -50,
      left: 0,
      right: 0,
      bottom: 0
  },
  overlayInner: {
        width: "100%",
        textAlign: "center",
        paddingTop: 150 
  }
})

interface Props extends React.HTMLProps<HTMLDivElement>{
  text?: string
  size?: number
  thickness?: number
  textColor?: "inherit" | "primary" | "secondary" | "textSecondary" | "error" | undefined
  spinnerColor?: "inherit" | "primary" | "secondary" | undefined
  overlay?: boolean
  compact?: boolean
}

type State = {
};

class LoadingView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {}; 
  }

  // UNSAFE_componentWillReceiveProps(newProps:Props & WithStyles<keyof typeof styles>){
  // }


  render () {


    const { classes }: { classes:ClassNameMap } = this.props
    const { text, size, thickness, textColor, spinnerColor, overlay, compact } = this.props



    if(overlay){
        return (
        <div className={classes.overlayContainer + " loading"}>
        <div className={classes.overlayInner}>
            <div>
            <Typography color={textColor || "textSecondary"} variant="h6" gutterBottom>
                { text || "Loading" }
            </Typography>
            </div>
            <div>
            <CircularProgress color={spinnerColor || "inherit"} size={size || 50} thickness={thickness || 5} className={classes.progress} />
            </div>
        </div>
        </div>
        );

    } else {

      var containerClass = classes.container
      if(compact){
        containerClass = classes.compactContainer
      }

        return (
        <div id="loading-view" className={containerClass}>
            <div>
            <Typography color={textColor || "textSecondary"} variant="h6" gutterBottom>
                { text || "Loading" }
            </Typography>
            </div>
            <div>
            <CircularProgress color={spinnerColor || "inherit"} size={size || 50} thickness={thickness || 5} className={classes.progress} />
            </div>
        </div>
        );
    }
  }
}

export default withStyles(styles)(LoadingView);
